import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import {
  IActionType,
  VARIABLE_TEXT_FEATURE_FLAG_TEXT,
  VariableSelectFeatureFlag,
  VariableTextFeatureFlag,
} from '@makyoapp/makyo-common'

import { BuilderComponentGroup, BuilderComponentSettingType, ComponentSettingKey, MdFabShape, MdShape } from '../types'
import { LABELS } from '../types/labels'
import {
  hoverEffectOptions,
  makeSpacing,
  makeTextColorSettings,
  makeTypography,
  makeTypographyGroup,
} from '../utils/components'

export const ButtonComponents: BuilderComponentGroup = {
  id: 'button',
  title: 'Buttons',
  components: [
    {
      compId: 'button',
      title: 'Button',
      searchKeywords: [
        'button',
        'CTA',
        'call to action',
        'submit',
        'click',
        'press',
        'action button',
        'link button',
        'primary button',
        'secondary button',
        'form button',
      ],
      icon: 'Button24',
      nested: false,
      //detailDataSource: undefined,
      settings: {
        data: [
          {
            id: ComponentSettingKey.ButtonDataLabel,
            type: BuilderComponentSettingType.VariableText,
            defaultValue: [
              {
                type: 'paragraph',
                children: [{ text: 'Submit' }],
              },
            ],
            label: LABELS.LABEL_KEY,
            variableTextSettings: {
              flags:
                VariableTextFeatureFlag.ColumnData |
                VariableTextFeatureFlag.SingleCell |
                VariableTextFeatureFlag.CurrentRow,
            },
          },
          {
            id: ComponentSettingKey.ButtonDataIcon,
            type: BuilderComponentSettingType.VariableSelect,
            label: LABELS.ICON_KEY,
            variableSelectSettings: {
              flags:
                VariableSelectFeatureFlag.ColumnData |
                VariableSelectFeatureFlag.SingleCell |
                VariableSelectFeatureFlag.CurrentRow |
                VariableSelectFeatureFlag.Icon,
              columnTypes: [ColumnTypes.Icon],
            },
          },
          {
            id: ComponentSettingKey.ButtonDataBadge,
            type: BuilderComponentSettingType.VariableText,
            label: 'Badge',
            autoDefaultInDetailPage: false,
            variableTextSettings: {
              flags:
                VariableTextFeatureFlag.ColumnData |
                VariableTextFeatureFlag.SingleCell |
                VariableTextFeatureFlag.CurrentRow,
            },
          },
        ],
        designGroup: {
          [LABELS.COLORS_KEY]: {
            items: [
              // {
              //   id: ComponentSettingKey.ButtonDesignColorVariant,
              //   type: BuilderComponentSettingType.ColorVariant,
              //   label: '',
              //   defaultValue: {
              //     light: 'primary-20',
              //     dark: 'primary-20',
              //   },
              // },
              {
                id: ComponentSettingKey.ButtonDesignGroupColor,
                type: BuilderComponentSettingType.Group,
                label: '',
                groupItems: {
                  [LABELS.COLOR_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.ButtonDesignColorType,
                      ComponentSettingKey.ButtonDesignColorTypeSolid,
                      ComponentSettingKey.ButtonDesignColorTypeStartGradient,
                      ComponentSettingKey.ButtonDesignColorTypeEndGradient,
                      ComponentSettingKey.ButtonDesignColorTypeGradientDirection,
                      ComponentSettingKey.ButtonDesignScheme,
                      LABELS.BACKGROUND_KEY,
                      'adaptive'
                    ).items,
                  ],
                  [LABELS.BADGE_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.ButtonDesignBadgeBackgroundColorType,
                      ComponentSettingKey.ButtonDesignBadgeBackgroundColorSolid,
                      ComponentSettingKey.ButtonDesignBadgeBackgroundColorStartGradient,
                      ComponentSettingKey.ButtonDesignBadgeBackgroundColorEndGradient,
                      ComponentSettingKey.ButtonDesignBadgeBackgroundColorGradientDirection,
                      ComponentSettingKey.ButtonDesignScheme,
                      LABELS.BADGE_KEY,
                      'adaptive'
                    ).items,
                  ],
                  // [LABELS.TEXT_KEY]: [
                  //   ...makeTextColorSettings(
                  //     ComponentSettingKey.ButtonDesignTextColor,
                  //     ComponentSettingKey.ButtonDesignTextColorSolid,
                  //     ComponentSettingKey.ButtonDesignTextColorStartGradient,
                  //     ComponentSettingKey.ButtonDesignTextColorEndGradient,
                  //     ComponentSettingKey.ButtonDesignTextColorGradientDirection,
                  //     ComponentSettingKey.ButtonDesignScheme,
                  //     LABELS.TEXT_KEY,
                  //     'adaptive'
                  //   ).items,
                  // ],
                  // [LABELS.BADGE_KEY]: [
                  //   ...makeTextColorSettings(
                  //     ComponentSettingKey.ButtonDesignBadgeColor,
                  //     ComponentSettingKey.ButtonDesignBadgeColorSolid,
                  //     ComponentSettingKey.ButtonDesignBadgeColorStartGradient,
                  //     ComponentSettingKey.ButtonDesignBadgeColorEndGradient,
                  //     ComponentSettingKey.ButtonDesignBadgeColorGradientDirection,
                  //     ComponentSettingKey.ButtonDesignScheme,
                  //     LABELS.BADGE_KEY,
                  //     'adaptive'
                  //   ).items,
                  // ],
                  // [LABELS.ICON_KEY]: [
                  //   ...makeTextColorSettings(
                  //     ComponentSettingKey.ButtonDesignIconColor,
                  //     ComponentSettingKey.ButtonDesignIconColorSolid,
                  //     undefined,
                  //     undefined,
                  //     undefined,
                  //     ComponentSettingKey.ButtonDesignScheme,
                  //     LABELS.ICON_KEY,
                  //     'adaptive',
                  //     {
                  //       showGradient: false,
                  //     }
                  //   ).items,
                  // ],
                },
              },
            ],
          },
          // [LABELS.VARIANT_KEY]: {
          //   items: [
          //     {
          //       id: ComponentSettingKey.ButtonDesignVariant,
          //       type: BuilderComponentSettingType.Select,
          //       label: '',
          //       selectSettings: {
          //         options: Object.entries(MdButtonVariant).map(([label, value]) => ({
          //           label,
          //           value,
          //         })),
          //       },
          //       defaultValue: 'filled',
          //     },
          //   ],
          // },
          [LABELS.ICON_POSITION_KEY]: {
            items: [
              {
                id: ComponentSettingKey.ButtonDesignIconPosition,
                type: BuilderComponentSettingType.Select,
                label: 'Position',
                defaultValue: 'leading',
                selectSettings: {
                  options: [
                    {
                      value: 'leading',
                      label: 'Leading',
                    },
                    {
                      value: 'trailing',
                      label: 'Trailing',
                    },
                  ],
                },
              },
            ],
          },
          [LABELS.CORNER_RADIUS_KEY]: {
            items: [
              {
                id: ComponentSettingKey.ButtonDesignShape,
                type: BuilderComponentSettingType.Select,
                label: '',
                defaultValue: MdShape.Medium,
                selectSettings: {
                  options: Object.entries(MdShape).map(([label, value]) => ({
                    value,
                    label: label.replace(/([a-z])([A-Z])/g, '$1 $2'),
                  })),
                },
              },
            ],
          },
          [LABELS.DIMENSION_KEY]: {
            items: [
              // {
              //   type: BuilderComponentSettingType.Switch,
              //   id: ComponentSettingKey.ButtonDesignFit,
              //   label: 'Fit',
              //   defaultValue: true,
              // },
              // {
              //   type: BuilderComponentSettingType.Slider,
              //   label: 'Width',
              //   id: ComponentSettingKey.ButtonDesignWidth,
              //   defaultValue: [100],
              //   sliderSettings: {
              //     max: 100,
              //     min: 10,
              //     step: 1,
              //     range: false,
              //     unit: '%',
              //   },
              // },
              {
                id: ComponentSettingKey.ButtonDesignFullWidth,
                type: BuilderComponentSettingType.Switch,
                label: 'Full width',
                defaultValue: false,
              },
              {
                id: ComponentSettingKey.ButtonDesignSize,
                type: BuilderComponentSettingType.Select,
                label: LABELS.BUTTON_SIZE_KEY,
                defaultValue: 'lg',
                selectSettings: {
                  options: Object.entries({
                    Small: 'sm',
                    Medium: 'md',
                    Large: 'lg',
                    // Icon: 'icon',
                  }).map(([label, value]) => ({
                    label,
                    value,
                  })),
                },
              },
            ],
          },
          [LABELS.ALIGNMENT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.ButtonDesignHAlign,
                type: BuilderComponentSettingType.ComponentAlignment,
                defaultValue: 'parent',
                label: LABELS.COMPONENT_ALIGNMENT_KEY,
              },
            ],
          },
          [LABELS.SPACING_KEY]: makeSpacing({
            padding: {
              id: ComponentSettingKey.ButtonDesignPadding,
              defaultValue: { x: 20, y: 10 },
            },
            margin: {
              id: ComponentSettingKey.ButtonDesignMargin,
              defaultValue: { x: 20, y: 10 },
            },
            paddingBadge: {
              id: ComponentSettingKey.ButtonDesignBadgePadding,
              defaultValue: { x: 10, y: 5 },
            },
          }),
          [LABELS.BADGE_POSITION_KEY]: {
            items: [
              {
                id: ComponentSettingKey.ButtonDesignBadgeTopPosition,
                type: BuilderComponentSettingType.Slider,
                label: LABELS.TOP_KEY,
                defaultValue: [-10],
                sliderSettings: {
                  max: 50,
                  min: -20,
                },
              },
              {
                id: ComponentSettingKey.ButtonDesignBadgeRightPosition,
                type: BuilderComponentSettingType.Slider,
                label: LABELS.RIGHT_KEY,
                defaultValue: [-10],
                sliderSettings: {
                  max: 50,
                  min: -20,
                },
              },
            ],
          },
          [LABELS.TYPOGRAPHY_KEY]: makeTypography(ComponentSettingKey.ButtonDesignTypography, 'Label Medium'),
          [LABELS.HOVER_EFFECT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.ButtonDesignHoverEffect,
                type: BuilderComponentSettingType.Select,
                label: LABELS.HOVER_EFFECT_KEY,
                selectSettings: {
                  options: hoverEffectOptions,
                },
              },
            ],
          },
        },
        action: [
          {
            label: LABELS.ON_CLICK_KEY,
            id: ComponentSettingKey.ButtonActionClick,
            isSimple: false,
          },
        ],
        behavior: {
          visibility: true,
        },
      },
    },
    {
      compId: 'fab',
      title: LABELS.FAB_KEY,
      searchKeywords: [
        'button',
        'floating action button',
        'FAB',
        'round button',
        'circle button',
        'quick add',
        'plus button',
        'shortcut button',
        'action button',
        'CTA',
        'mobile button',
      ],
      icon: 'FabRight16',
      nested: false,
      isDetailPageComponent: false,
      settings: {
        dataGroup: {
          [LABELS.PRIMARY_KEY]: {
            items: [
              {
                id: ComponentSettingKey.Fab1DataActive,
                label: LABELS.ACTIVE_KEY,
                type: BuilderComponentSettingType.Switch,
                defaultValue: true,
              },
              {
                id: ComponentSettingKey.Fab1DataIcon,
                type: BuilderComponentSettingType.VariableSelect,
                autoDefaultInDetailPage: false,
                label: LABELS.ICON_KEY,
                defaultValue: {
                  flag: VariableSelectFeatureFlag.Icon,
                  value: 'add',
                },
                variableSelectSettings: {
                  flags: VariableSelectFeatureFlag.Icon,
                  columnTypes: [ColumnTypes.Icon],
                },
                dependOn: {
                  id: ComponentSettingKey.Fab1DataActive,
                  showWhen: (value) => value === true,
                },
              },
              {
                id: ComponentSettingKey.Fab1DataLabel,
                type: BuilderComponentSettingType.VariableText,
                variableTextSettings: {
                  flags: VARIABLE_TEXT_FEATURE_FLAG_TEXT,
                },
                autoDefaultInDetailPage: false,
                defaultValue: [
                  {
                    type: 'paragraph',
                    children: [{ text: '' }],
                  },
                ],
                label: LABELS.LABEL_KEY,
                dependOn: {
                  id: ComponentSettingKey.Fab1DataActive,
                  showWhen: (value) => value === true,
                },
              },
              {
                id: ComponentSettingKey.Fab1DataBadge,
                type: BuilderComponentSettingType.VariableText,
                label: LABELS.BADGE_KEY,
                autoDefaultInDetailPage: false,
                variableTextSettings: {
                  flags: VARIABLE_TEXT_FEATURE_FLAG_TEXT,
                },
                dependOn: {
                  id: ComponentSettingKey.Fab1DataActive,
                  showWhen: (value) => value === true,
                },
              },
            ],
          },
          [LABELS.SECONDARY_KEY]: {
            items: [
              {
                id: ComponentSettingKey.Fab2DataActive,
                label: LABELS.ACTIVE_KEY,
                type: BuilderComponentSettingType.Switch,
                defaultValue: false,
              },
              {
                id: ComponentSettingKey.Fab2DataIcon,
                type: BuilderComponentSettingType.VariableSelect,
                label: LABELS.ICON_KEY,
                autoDefaultInDetailPage: false,
                defaultValue: {
                  flag: VariableSelectFeatureFlag.Icon,
                  value: 'phone_in_talk',
                },
                variableSelectSettings: {
                  flags: VariableSelectFeatureFlag.Icon,
                  columnTypes: [ColumnTypes.Icon],
                },
                dependOn: {
                  id: ComponentSettingKey.Fab2DataActive,
                  showWhen: (value) => value === true,
                },
              },
              {
                id: ComponentSettingKey.Fab2DataLabel,
                type: BuilderComponentSettingType.VariableText,
                variableTextSettings: {
                  flags: VARIABLE_TEXT_FEATURE_FLAG_TEXT,
                },
                label: LABELS.LABEL_KEY,
                autoDefaultInDetailPage: false,
                dependOn: {
                  id: ComponentSettingKey.Fab2DataActive,
                  showWhen: (value) => value === true,
                },
              },
              {
                id: ComponentSettingKey.Fab2DataBadge,
                type: BuilderComponentSettingType.VariableText,
                label: LABELS.BADGE_KEY,
                autoDefaultInDetailPage: false,
                variableTextSettings: {
                  flags: VARIABLE_TEXT_FEATURE_FLAG_TEXT,
                },
                dependOn: {
                  id: ComponentSettingKey.Fab2DataActive,
                  showWhen: (value) => value === true,
                },
              },
            ],
          },
        },
        designGroup: {
          [LABELS.COLORS_KEY]: {
            items: [
              {
                id: ComponentSettingKey.Fab1DesignColorVariant,
                label: LABELS.PRIMARY_KEY,
                type: BuilderComponentSettingType.ColorVariant,
                defaultValue: {
                  light: 'secondary-30',
                  dark: 'secondary-30',
                },
              },
              {
                id: ComponentSettingKey.Fab2DesignColorVariant,
                label: LABELS.SECONDARY_KEY,
                type: BuilderComponentSettingType.ColorVariant,
                defaultValue: {
                  light: 'tertiary-30',
                  dark: 'tertiary-30',
                },
              },
            ],
          },
          //* hidden for now
          // Size: {
          //   items: [
          //     {
          //       id: ComponentSettingKey.Fab1DesignSize,
          //       type: BuilderComponentSettingType.Select,
          //       label: 'Primary',
          //       defaultValue: 'small',
          //       selectSettings: {
          //         options: [
          //           { value: 'small', label: 'Small' },
          //           { value: 'medium', label: 'Medium' },
          //           { value: 'large', label: 'Large' },
          //         ],
          //       },
          //       dependOn: {
          //         id: ComponentSettingKey.Fab1DataActive,
          //         showWhen: (value) => value === true,
          //       },
          //     },
          //     {
          //       id: ComponentSettingKey.Fab2DesignSize,
          //       type: BuilderComponentSettingType.Select,
          //       label: 'Secondary',
          //       defaultValue: 'small',
          //       selectSettings: {
          //         options: [
          //           { value: 'small', label: 'Small' },
          //           { value: 'medium', label: 'Medium' },
          //           { value: 'large', label: 'Large' },
          //         ],
          //       },
          //       dependOn: {
          //         id: ComponentSettingKey.Fab2DataActive,
          //         showWhen: (value) => value === true,
          //       },
          //     },
          //   ],
          // },
          // [LABELS.VARIANT_KEY]: {
          //   items: [
          //     {
          //       id: ComponentSettingKey.Fab1DesignVariant,
          //       type: BuilderComponentSettingType.Select,
          //       label: LABELS.PRIMARY_KEY,
          //       defaultValue: 'primary',
          //       selectSettings: {
          //         options: [
          //           { value: 'surface', label: 'Surface' },
          //           { value: 'primary', label: 'Primary' },
          //           { value: 'secondary', label: 'Secondary' },
          //           { value: 'tertiary', label: 'Tertiary' },
          //         ],
          //       },
          //       dependOn: {
          //         id: ComponentSettingKey.Fab1DataActive,
          //         showWhen: (value) => value === true,
          //       },
          //     },
          //     {
          //       id: ComponentSettingKey.Fab2DesignVariant,
          //       type: BuilderComponentSettingType.Select,
          //       label: LABELS.SECONDARY_KEY,
          //       defaultValue: 'tertiary',
          //       selectSettings: {
          //         options: [
          //           { value: 'surface', label: 'Surface' },
          //           { value: 'primary', label: 'Primary' },
          //           { value: 'secondary', label: 'Secondary' },
          //           { value: 'tertiary', label: 'Tertiary' },
          //         ],
          //       },
          //       dependOn: {
          //         id: ComponentSettingKey.Fab2DataActive,
          //         showWhen: (value) => value === true,
          //       },
          //     },
          //   ],
          // },
          [LABELS.SHADOW_KEY]: {
            items: [
              {
                id: ComponentSettingKey.Fab1DesignShadow,
                type: BuilderComponentSettingType.Select,
                label: LABELS.PRIMARY_KEY,
                defaultValue: 'default',
                selectSettings: {
                  options: [
                    { value: 'default', label: 'Default' },
                    { value: 'lowered', label: 'Lowered' },
                    { value: 'none', label: 'None' },
                  ],
                },
                dependOn: {
                  id: ComponentSettingKey.Fab1DataActive,
                  showWhen: (value) => value === true,
                },
              },
              {
                id: ComponentSettingKey.Fab2DesignShadow,
                type: BuilderComponentSettingType.Select,
                label: LABELS.SECONDARY_KEY,
                defaultValue: 'default',
                selectSettings: {
                  options: [
                    { value: 'default', label: 'Default' },
                    { value: 'lowered', label: 'Lowered' },
                    { value: 'none', label: 'None' },
                  ],
                },
                dependOn: {
                  id: ComponentSettingKey.Fab2DataActive,
                  showWhen: (value) => value === true,
                },
              },
            ],
          },
          [LABELS.CORNER_RADIUS_KEY]: {
            items: [
              {
                id: ComponentSettingKey.Fab1DesignShape,
                type: BuilderComponentSettingType.Select,
                label: LABELS.PRIMARY_KEY,
                defaultValue: MdFabShape.DropBotRight,
                selectSettings: {
                  options: [
                    { value: 'rounded', label: 'Rounded' },
                    { value: 'circle', label: 'Circle' },
                    { value: 'square', label: 'Square' },
                    { value: 'drop-br', label: 'Drop Bottom-Right' },
                    { value: 'drop-bl', label: 'Drop Bottom-Left' },
                    { value: 'drop-tr', label: 'Drop Top-Right' },
                    { value: 'drop-tl', label: 'Drop Top-Left' },
                  ],
                },
                dependOn: {
                  id: ComponentSettingKey.Fab1DataActive,
                  showWhen: (value) => value === true,
                },
              },
              {
                id: ComponentSettingKey.Fab2DesignShape,
                type: BuilderComponentSettingType.Select,
                label: LABELS.SECONDARY_KEY,
                defaultValue: MdFabShape.Circle,
                selectSettings: {
                  options: [
                    { value: 'rounded', label: 'Rounded' },
                    { value: 'circle', label: 'Circle' },
                    { value: 'square', label: 'Square' },
                    { value: 'drop-br', label: 'Drop Bottom-Right' },
                    { value: 'drop-bl', label: 'Drop Bottom-Left' },
                    { value: 'drop-tr', label: 'Drop Top-Right' },
                    { value: 'drop-tl', label: 'Drop Top-Left' },
                  ],
                },
                dependOn: {
                  id: ComponentSettingKey.Fab2DataActive,
                  showWhen: (value) => value === true,
                },
              },
            ],
          },
          [LABELS.ALIGNMENT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.FabDesignHAlign,
                type: BuilderComponentSettingType.HorizontalAlignment,
                defaultValue: 'end',
                label: LABELS.ALIGNMENT_KEY,
              },
            ],
          },
          [LABELS.TYPOGRAPHY_KEY]: makeTypographyGroup(ComponentSettingKey.FabDesignTypography, [
            {
              id: ComponentSettingKey.Fab1DesignTypography,
              label: LABELS.PRIMARY_KEY,
              defaultValue: 'Label Small',
            },
            {
              id: ComponentSettingKey.Fab2DesignTypography,
              label: LABELS.SECONDARY_KEY,
              defaultValue: 'Label Small',
            },
          ]),
          [LABELS.HOVER_EFFECT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.FabDesignHoverEffect,
                type: BuilderComponentSettingType.Select,
                label: LABELS.HOVER_EFFECT_KEY,
                selectSettings: {
                  options: hoverEffectOptions,
                },
              },
            ],
          },
        },
        action: [
          {
            label: LABELS.ON_PRIMARY_FAB_CLICK_KEY,
            id: ComponentSettingKey.Fab1ActionClick,
            isSimple: false,
            dependOn: {
              id: ComponentSettingKey.Fab1DataActive,
              showWhen: (value) => value === true,
            },
          },
          {
            label: LABELS.ON_SECONDARY_FAB_CLICK_KEY,
            id: ComponentSettingKey.Fab2ActionClick,
            isSimple: false,
            dependOn: {
              id: ComponentSettingKey.Fab2DataActive,
              showWhen: (value) => value === true,
            },
          },
        ],
        behavior: {
          visibility: true,
        },
      },
    },
    {
      compId: 'icon',
      title: LABELS.ICON_KEY,
      searchKeywords: [
        'icon',
        'symbol',
        'pictogram',
        'glyph',
        'graphic',
        'emoji',
        'material icon',
        'icon button',
        'action button',
        'button with icon',
        'clickable icon',
      ],
      icon: 'Icon24',
      nested: false,
      //detailDataSource: undefined,
      settings: {
        data: [
          {
            id: ComponentSettingKey.IconButtonDataIcon,
            type: BuilderComponentSettingType.VariableSelect,
            label: LABELS.ICON_KEY,
            defaultValue: {
              flag: VariableSelectFeatureFlag.Icon,
              value: 'star',
            },
            variableSelectSettings: {
              flags:
                VariableSelectFeatureFlag.ColumnData |
                VariableSelectFeatureFlag.SingleCell |
                VariableSelectFeatureFlag.CurrentRow |
                VariableSelectFeatureFlag.Icon,
              columnTypes: [ColumnTypes.Icon, ColumnTypes.Lookup],
            },
          },
          {
            id: ComponentSettingKey.IconButtonDataIconActive,
            type: BuilderComponentSettingType.VariableSelect,
            label: LABELS.ACTIVE_ICON_KEY,
            defaultValue: {
              flag: VariableSelectFeatureFlag.Icon,
              value: 'star',
            },
            variableSelectSettings: {
              flags:
                VariableSelectFeatureFlag.ColumnData |
                VariableSelectFeatureFlag.SingleCell |
                VariableSelectFeatureFlag.CurrentRow |
                VariableSelectFeatureFlag.Icon,
              columnTypes: [ColumnTypes.Icon],
            },
            help: 'Used when toggle option is enabled. If not specified the normal icon will be used.',
          },
          {
            id: ComponentSettingKey.IconButtonDataBadge,
            type: BuilderComponentSettingType.VariableText,
            label: LABELS.BADGE_KEY,
            variableTextSettings: {
              flags: VARIABLE_TEXT_FEATURE_FLAG_TEXT,
            },
            autoDefaultInDetailPage: false,
          },
          {
            id: ComponentSettingKey.IconButtonDataToggle,
            type: BuilderComponentSettingType.VariableSelect,
            label: LABELS.DATA_TO_TOGGLE_KEY,
            variableSelectSettings: {
              flags:
                VariableSelectFeatureFlag.ColumnData |
                VariableSelectFeatureFlag.SingleCell |
                VariableSelectFeatureFlag.CurrentRow |
                VariableSelectFeatureFlag.ProfileData,
              tableSourceId: ComponentSettingKey.IconButtonDataIcon,
              columnTypes: [ColumnTypes.Boolean, ColumnTypes.Function, ColumnTypes.Lookup, ColumnTypes.Connection],
            },
            help: 'Used to enable toggle option',
          },
        ],
        designGroup: {
          [LABELS.COLOR_KEY]: {
            items: [
              // makeScheme(ComponentSettingKey.IconButtonDesignScheme),
              // {
              //   id: ComponentSettingKey.IconButtonDesignColorVariant,
              //   type: BuilderComponentSettingType.ColorVariant,
              //   label: LABELS.ACCENT_COLOR_KEY,
              //   defaultValue: 'primary',
              //   colorVariantSettings: {
              //     fullColor: 'bg',
              //     schemeId: ComponentSettingKey.IconButtonDesignScheme,
              //   },
              // },
              {
                id: ComponentSettingKey.IconButtonDesignIconColorVariant,
                type: BuilderComponentSettingType.ColorVariant,
                label: 'Active Color',
                defaultValue: {
                  light: 'primary-20',
                  dark: 'primary-20',
                },
              },
              {
                id: ComponentSettingKey.IconButtonDesignIconInactiveColor,
                type: BuilderComponentSettingType.ColorVariant,
                label: 'Inactive Color',
                defaultValue: {
                  light: 'primary-20',
                  dark: 'primary-20',
                },
              },
            ],
          },
          [LABELS.DIMENSION_KEY]: {
            items: [
              {
                id: ComponentSettingKey.IconButtonDesignIconSize,
                type: BuilderComponentSettingType.Slider,
                defaultValue: [48],
                label: 'Size',
                sliderSettings: {
                  max: 1200,
                  min: 16,
                  range: false,
                  step: 1,
                },
              },
              // {
              //   id: ComponentSettingKey.IconButtonDesignIconWeight,
              //   type: BuilderComponentSettingType.Slider,
              //   defaultValue: [200],
              //   label: 'Weight',
              //   sliderSettings: {
              //     max: 700,
              //     min: 100,
              //     range: false,
              //     step: 100,
              //     showMark: true,
              //   },
              // },
              // {
              //   id: ComponentSettingKey.IconButtonDesignIconGrade,
              //   type: BuilderComponentSettingType.SliderSelect,
              //   defaultValue: 0,
              //   label: 'Grade',
              //   sliderSelectSettings: {
              //     options: [-25, 0, 200],
              //   },
              // },
            ],
          },
          // [LABELS.VARIANT_KEY]: {
          //   items: [
          //     {
          //       id: ComponentSettingKey.IconButtonDesignVariant,
          //       type: BuilderComponentSettingType.Select,
          //       label: LABELS.VARIANT_KEY,
          //       defaultValue: MdIconButtonVariant.Filled,
          //       selectSettings: {
          //         options: Object.entries(MdIconButtonVariant)
          //           .filter(([k, v]) => v !== MdIconButtonVariant.Elevated)
          //           .map(([label, value]) => ({
          //             label,
          //             value,
          //           })),
          //       },
          //     },
          //     {
          //       id: ComponentSettingKey.IconButtonDesignToggledVariant,
          //       type: BuilderComponentSettingType.Select,
          //       label: LABELS.TOGGLED_VARIANT_KEY,
          //       defaultValue: MdIconButtonVariant.Filled,
          //       selectSettings: {
          //         options: Object.entries(MdIconButtonVariant)
          //           .filter(([k, v]) => v !== MdIconButtonVariant.Elevated)
          //           .map(([label, value]) => ({
          //             label,
          //             value,
          //           })),
          //       },
          //     },
          //   ],
          // },
          [LABELS.CORNER_RADIUS_KEY]: {
            items: [
              {
                id: ComponentSettingKey.IconButtonDesignShape,
                type: BuilderComponentSettingType.Select,
                label: LABELS.CORNER_RADIUS_KEY,
                defaultValue: MdShape.Full,
                selectSettings: {
                  options: Object.entries(MdShape).map(([label, value]) => ({
                    value,
                    label: label.replace(/([a-z])([A-Z])/g, '$1 $2'),
                  })),
                },
              },
            ],
          },
          [LABELS.ALIGNMENT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.IconButtonDesignHAlign,
                type: BuilderComponentSettingType.ComponentAlignment,
                defaultValue: 'parent',
                label: LABELS.COMPONENT_ALIGNMENT_KEY,
              },
            ],
          },
          [LABELS.SPACING_KEY]: makeSpacing({
            margin: {
              id: ComponentSettingKey.IconButtonDesignMargin,
              defaultValue: { y: 5, x: 20 },
            },
            padding: {
              id: ComponentSettingKey.IconButtonDesignPadding,
              defaultValue: { y: 5, x: 20 },
            },
          }),
          [LABELS.TEXT_COLORS_OPTION_KEY]: {
            items: [
              {
                id: ComponentSettingKey.IconButtonDesignGroupColor,
                type: BuilderComponentSettingType.Group,
                label: '',
                groupItems: {
                  [LABELS.ACTIVE_ICON_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.IconButtonDesignActiveColor,
                      ComponentSettingKey.IconButtonDesignActiveColorSolid,
                      undefined,
                      undefined,
                      undefined,
                      ComponentSettingKey.IconButtonDesignScheme,
                      'Active Icon',
                      'adaptive',
                      {
                        showGradient: false,
                      }
                    ).items,
                  ],
                  [LABELS.INACTIVE_ICON_KEY]: [
                    ...makeTextColorSettings(
                      ComponentSettingKey.IconButtonDesignInActiveColor,
                      ComponentSettingKey.IconButtonDesignInActiveColorSolid,
                      undefined,
                      undefined,
                      undefined,
                      ComponentSettingKey.IconButtonDesignScheme,
                      'Inactive Icon',
                      'adaptive',
                      {
                        showGradient: false,
                      }
                    ).items,
                  ],
                },
              },
            ],
          },
          [LABELS.HOVER_EFFECT_KEY]: {
            items: [
              {
                id: ComponentSettingKey.IconButtonDesignHoverEffect,
                type: BuilderComponentSettingType.Select,
                label: LABELS.HOVER_EFFECT_KEY,
                selectSettings: {
                  options: hoverEffectOptions,
                },
              },
            ],
          },
        },
        action: [
          {
            label: LABELS.ON_CLICK_KEY,
            id: ComponentSettingKey.IconButtonActionClick,
            isSimple: false,
          },
        ],
        behavior: {
          visibility: true,
        },
      },
    },
    /*{
      type: 'segmented',
      title: 'Segmented',
      icon: 'Segmented24',
      nested: false,
      settings: {}
    },
    {
      type: 'chip',
      title: 'Chip',
      icon: 'Chip24',
      nested: false,
      settings: {}
    }*/
  ],
}
